import { AdminUserList, AdminUserEdit, AdminUserCreate } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        AdminUserList,
        AdminUserEdit,
        AdminUserCreate,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'adminUser',
    icon: 'fa-user-shield',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/AdminUser/index.ts